import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { fetchJson } from "../../lib/Fetching";

class TopicsInput extends React.Component {
  state = {
    focused: false,
    topics: [],
  };

  onBlur = () => {
    this.setState({ focused: false });
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  fetchData = (search) => {
    const { onChange } = this.props;
    fetchJson("/topics/topics.json", {}).then((records) => {
      const topics = records.map((m) => ({ label: m.name, value: m.id }));
      this.setState({ topics });
      if (topics.length == 1) {
        onChange(topics[0]);
      }
    });
  };

  componentDidMount() {
    this.fetchData();
  }

  customStyles = () => {
    const { width, defaultStyle } = this.props;
    if (defaultStyle) return {};
    return {
      control: (base, state) => ({
        ...base,
        width: width || 300,
      }),
    };
  };

  render() {
    const { onChange, multiple, value, clientView } = this.props;
    const { topics } = this.state;
    if ((clientView && topics.length == 1) || topics.length === 0) return null;
    const selectedValue = value ? topics.filter((o) => o.value == value) : undefined;
    return (
      <Select
        value={selectedValue}
        placeholder={"Select Topic"}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        isMulti={multiple}
        simpleValue={true}
        autoload={true}
        styles={this.customStyles()}
        id="topic_id"
        options={topics}
        isClearable
        onChange={onChange}
      />
    );
  }
}

export default TopicsInput;
